import { Component, OnInit } from '@angular/core';

@Component({
    template: require('./not-tenant-page.component.html'),
    styles: [require('./not-tenant-page.component.css')]
})
export class NotTenantPageComponent implements OnInit {
    domain: string;

    ngOnInit() {
        this.domain = window.location.href;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pages/not-tenant-page/not-tenant-page.component.ts
 **/